/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PatientRelatedPersonsPatientRelatedPerson from './PatientRelatedPersonsPatientRelatedPerson';

/**
 * The PatientRelatedPersonsBody model module.
 * @module model/PatientRelatedPersonsBody
 * @version v0.3
 */
export default class PatientRelatedPersonsBody {
  /**
   * Constructs a new <code>PatientRelatedPersonsBody</code>.
   * @alias module:model/PatientRelatedPersonsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PatientRelatedPersonsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientRelatedPersonsBody} obj Optional instance to populate.
   * @return {module:model/PatientRelatedPersonsBody} The populated <code>PatientRelatedPersonsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientRelatedPersonsBody();
      if (data.hasOwnProperty('patient_related_person'))
        obj.patientRelatedPerson = PatientRelatedPersonsPatientRelatedPerson.constructFromObject(data['patient_related_person']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PatientRelatedPersonsPatientRelatedPerson} patientRelatedPerson
 */
PatientRelatedPersonsBody.prototype.patientRelatedPerson = undefined;

